import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  Autocomplete,
  Typography,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogContent,
} from "@mui/material";
import { UseArticles } from "./UseArticles";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu, rsParentChilds } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import AuthorsGrid from "./AuthorsGrid";
import ArticleImagesGrid from "./ArticleImagesGrid";
import ArticleResourcesGrid from "./ArticleResourcesGrid";
import ArticleAdvsGrid from "./ArticleAdvsGrid";
import ArticleProductsGrid from "./ArticleProductsGrid";
import CheckIcon from "@mui/icons-material/Check";
import SelectGroup from "../firstPage/HomeOffer/SelectGroup";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddArticle() {
  const { toSolar } = require("jdate-convert");
  const { enqueueSnackbar } = useSnackbar();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const {
    validate,
    GetAuthors,
    GetArticleGroups,
    GetArticleByID,
    UpdateArticle,
  } = UseArticles();
  const [selectedState, setSelectedState] = useState();
  const [name, setName] = useState();
  const [resources, setResources] = useState();
  const [openShowGroup, setOpenShowGroup] = useState(false);
  const [authorAssistant, setAuthorAssistant] = useState();
  const { isSmall } = useBreakpoints();

  const [valueStart, setValueStart] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const ArticleType = [
    { id: 1, type: "متنی" },
    { id: 2, type: "ویدیو" },
    { id: 3, type: "پادکست" },
    { id: 4, type: "اینفوگرافی" },
    { id: 5, type: "اطلاعیه" },
  ];
  const [parentID, setParentID] = useRecoilState(rsParentChilds);
  const [statePG, setStatePG] = useState({
    name: undefined,
    productGroupID: undefined,
  });
  const [state, setState] = useState({
    id: "",
    faTitle: undefined,
    enTitle: undefined,
    articleType: undefined,
    groupID: undefined,
    authorID: undefined,
    content: undefined,
    contentSum: undefined,
    isPublish: false,
    logdate: undefined,
    productGroupID: undefined,
  });

  const [errorState, setErrorState] = useState({
    faTitle: false,
    enTitle: false,
    articleType: false,
    groupID: false,
    authorID: false,
    content: false,
    contentSum: false,
    isPublish: false,
  });

  const [authors, setAuthors] = useState();
  const [articleGroups, setArticleGroups] = useState();

  useEffect(() => {
    GetAuthors((authors) => {
      setAuthors(authors.authors);
    });
    GetArticleGroups((articleGroups) => {
      setArticleGroups(articleGroups.groups);
    });
  }, []);

  useEffect(() => {
    if (location.state && location.state.id) {
      setProgress(true);
      GetArticleByID(location.state.id, (callback) => {
        setResources(callback.resources ? callback.resources : []);
        setAuthorAssistant(
          callback.authorAssistant ? callback.authorAssistant : []
        );
        setName(callback.productGroup?.groupName);
        setState(callback);
      });
    }
  }, [location.state]);

  useEffect(() => {
    let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setState({ ...state, logdate: newValueStart });
  }, [valueStart]);

  function getBYID() {
    GetArticleByID(state.id, (callback) => {
      setResources(callback.resources ? callback.resources : []);
      setAuthorAssistant(
        callback.authorAssistant ? callback.authorAssistant : []
      );
      setName(callback.productGroup?.groupName);
      setState(callback);
    });
  }

  useEffect(() => {
    if (selectedState) {
      const element = document.getElementById(selectedState);
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 1000);
    }
  }, [selectedState]);

  return (
    <Detail
      breadChilds={{
        normargin: true,
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/articles" },
          {
            name: "ویرایش مقاله" + " (" + state?.id + " )",
            url: "/articles/editArticle",
          },
        ],
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: -5,
          bgcolor: "#f4f4f4",
          zIndex: 1000,
          boxShadow: 3,
          p: 1,
          width: "100%",
          overflowX: "auto",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Button
            sx={{ width: "100px", mr: 2 }}
            variant={selectedState == "Content" ? "contained" : "outlined"}
            startIcon={selectedState == "Content" && <CheckIcon />}
            onClick={() => {
              setSelectedState("Content");
            }}
          >
            متن مقاله
          </Button>
          <Button
            sx={{ width: "100px", mr: 2 }}
            startIcon={selectedState == "ContentSum" && <CheckIcon />}
            variant={selectedState == "ContentSum" ? "contained" : "outlined"}
            onClick={() => {
              setSelectedState("ContentSum");
            }}
          >
            خلاصه
          </Button>
          <Button
            sx={{
              width: "100px",
              mr: 2,
            }}
            startIcon={selectedState == "ArticleImage" && <CheckIcon />}
            variant={selectedState == "ArticleImage" ? "contained" : "outlined"}
            onClick={() => {
              setSelectedState("ArticleImage");
            }}
          >
            تصاویر
          </Button>
          <Button
            sx={{
              width: "100px",
              mr: 2,
            }}
            startIcon={selectedState == "ArticleProducts" && <CheckIcon />}
            variant={
              selectedState == "ArticleProducts" ? "contained" : "outlined"
            }
            onClick={() => {
              setSelectedState("ArticleProducts");
            }}
          >
            محصولات
          </Button>
          <Button
            sx={{
              width: "100px",
              mr: 2,
            }}
            startIcon={selectedState == "ArticleAdv" && <CheckIcon />}
            variant={selectedState == "ArticleAdv" ? "contained" : "outlined"}
            onClick={() => {
              setSelectedState("ArticleAdv");
            }}
          >
            تبلیغات
          </Button>
          <Button
            sx={{
              width: "100px",
              mr: 2,
            }}
            startIcon={selectedState == "ArticleAuthors" && <CheckIcon />}
            variant={
              selectedState == "ArticleAuthors" ? "contained" : "outlined"
            }
            onClick={() => {
              setSelectedState("ArticleAuthors");
            }}
          >
            نویسندگان
          </Button>
          <Button
            sx={{
              width: "100px",
              mr: 2,
            }}
            startIcon={selectedState == "ArticleResource" && <CheckIcon />}
            variant={
              selectedState == "ArticleResource" ? "contained" : "outlined"
            }
            onClick={() => {
              setSelectedState("ArticleResource");
            }}
          >
            منابع
          </Button>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Button
            sx={{ mr: 2, width: "80px" }}
            variant="contained"
            color="secondary"
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                setProgress(true);
                UpdateArticle(state, () => {
                  navigate("/articles", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "80px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/articles", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
      {!brand ? (
        <Box
          sx={{ p: 2 }}
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={3}
        >
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              value={state.faTitle ? state.faTitle : ""}
              error={errorState.faTitle}
              label="عنوان فارسی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, faTitle: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.enTitle ? state.enTitle : ""}
              error={errorState.enTitle}
              sx={{
                input: { direction: "rtl" },
              }}
              label="عنوان لاتین"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, enTitle: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <Autocomplete
              size="small"
              value={state.articleType ? state.articleType : ""}
              onChange={(event, newValue) => {
                setState({ ...state, articleType: newValue });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return ArticleType.find((m) => m.id == option).type;
                }
                return "";
              }}
              options={ArticleType ? ArticleType.map((m) => m.id) : []}
              renderInput={(params) => (
                <TextField
                  error={errorState.articleType}
                  variant="outlined"
                  {...params}
                  label="نوع مقاله"
                />
              )}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <Autocomplete
              size="small"
              value={state.groupID ? state.groupID : ""}
              onChange={(event, newValue) => {
                setState({ ...state, groupID: newValue });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return articleGroups?.find((m) => m.id == option)?.faName;
                }
                return "";
              }}
              options={articleGroups ? articleGroups.map((m) => m.id) : []}
              renderInput={(params) => (
                <TextField
                  error={errorState.groupID}
                  variant="outlined"
                  {...params}
                  label="گروه مقاله"
                />
              )}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={name ? name : ""}
              error={errorState.faTitle}
              label="گروه محصول"
              size="small"
              onChange={(evt) => {
                setState({ ...state, faTitle: evt.target.value });
              }}
              variant="filled"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Box>
          <Box
            gridColumn="span 9"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Button
              sx={{ width: "80px", mr: 2 }}
              onClick={() => {
                setOpenShowGroup(true);
              }}
              variant="contained"
            >
              انتخاب
            </Button>
            <Button
              sx={{ width: "80px" }}
              onClick={() => {
                setName("");
                setState({
                  ...state,
                  productGroupID: 0,
                });
              }}
              color="secondary"
              variant="contained"
            >
              حذف
            </Button>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <Autocomplete
              size="small"
              value={state.authorID ? state.authorID : ""}
              onChange={(event, newValue) => {
                setState({ ...state, authorID: newValue });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return authors?.find((m) => m.id == option)?.author;
                }
                return "";
              }}
              options={authors ? authors.map((m) => m.id) : []}
              renderInput={(params) => (
                <TextField
                  error={errorState.authorID}
                  variant="outlined"
                  {...params}
                  label="نویسنده مقاله"
                />
              )}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              value={state && state.logdate ? toSolar(state.logdate) : ""}
              onChange={setValueStart}
              render={
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="تاریخ انتشار"
                />
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.isPublish}
                  onChange={(event) =>
                    setState({
                      ...state,
                      isPublish: event.target.checked,
                    })
                  }
                />
              }
              label="مقاله منتشر شود"
            />
          </Box>
          <Box id="Content" gridColumn="span 12">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Typography color="secondary" variant="subtitle1">
                متن مقاله :{" "}
              </Typography>
              {/* <Button
                sx={{ width: "80px" }}
                variant="contained"
                color="secondary"
                href="/brands"
                target="_blank"
              >
                ویدیوها
              </Button> */}
            </Box>
            <Box className="fullCk" sx={{ height: "100%" }}>
              {state.id !== "" && (
                <CKEditor
                  config={{
                    language: "fa",
                    link: {
                      decorators: {
                        addTargetToExternalLinks: {
                          mode: "automatic",
                          callback: (url) => /^(https?:)?\/\//.test(url),
                          attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                      },
                    },
                  }}
                  editor={Editor}
                  data={state.content ? state.content : ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    if (state.id) {
                      setState({ ...state, content: data });
                    }
                  }}
                  onReady={(editor) => {
                    editor.editing.view.change((writer) => {
                      writer.setStyle(
                        "height",
                        "500px",
                        editor.editing.view.document.getRoot()
                      );
                    });
                  }}
                />
              )}
            </Box>
          </Box>
          <Box id="ContentSum" gridColumn="span 12">
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              خلاصه مقاله :{" "}
            </Typography>
            <TextField
              value={state.contentSum ? state.contentSum : ""}
              fullWidth
              error={errorState.faTitle}
              // label=" خلاصه مقاله "
              size="small"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              multiline
              rows={10}
              onChange={(event, editor) => {
                setState({ ...state, contentSum: event.target.value });
              }}
            />
          </Box>
          <Box id="ArticleImage" gridColumn="span 12">
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              تصاویر مقاله :{" "}
            </Typography>
            <ArticleImagesGrid
              articleID={state.id && state.id}
              callback={() => getBYID()}
            />
          </Box>
          <Box id="ArticleProducts" gridColumn="span 12">
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              محصولات مرتبط :{" "}
            </Typography>
            <ArticleProductsGrid articleID={state.id && state.id} />
          </Box>
          <Box id="ArticleAdv" gridColumn="span 12">
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              تبلیغات مقاله :{" "}
            </Typography>
            <ArticleAdvsGrid articleID={state.id && state.id} />
          </Box>
          <Box id="ArticleAuthors" gridColumn="span 12">
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              کمک نویسندگان مقاله :{" "}
            </Typography>
            <AuthorsGrid
              articleID={state.id && state.id}
              callback={() => getBYID()}
              rows={authorAssistant ? authorAssistant : []}
            />
          </Box>
          <Box id="ArticleResource" gridColumn="span 12">
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              منابع مقاله :{" "}
            </Typography>
            <ArticleResourcesGrid
              articleID={state.id && state.id}
              rows={resources ? resources : []}
              callback={() => getBYID()}
            />
          </Box>

          <Dialog
            PaperProps={{
              elevation: 1,
            }}
            fullWidth
            maxWidth="xl"
            open={openShowGroup}
            onClose={() => {
              setParentID({
                id: undefined,
                name: undefined,
              });
              setOpenShowGroup(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent
              sx={{
                height: "auto",
                display: "flex",
                my: "auto",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <SelectGroup
                article
                setName={setName}
                validation={errorState.productGroupID}
                // selectedGroupID={state.productGroupID && state.productGroupID}
                setter={setStatePG}
                lvl1State={statePG}
              ></SelectGroup>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Button
                  sx={{ mr: 1, mt: 2, width: "70px" }}
                  variant="contained"
                  onClick={() => {
                    setName(statePG.name);
                    setState({
                      ...state,
                      productGroupID: statePG.productGroupID,
                    });
                    enqueueSnackbar(
                      "گروه (( " +
                        [statePG.name] +
                        "  )) با موفقیت  انتخاب شد .",
                      {
                        variant: "success",
                        autoHideDuration: 3000,
                        preventDuplicate: true,
                      }
                    );
                    setParentID({
                      id: undefined,
                      name: undefined,
                    });
                    setOpenShowGroup(false);
                  }}
                >
                  ثبت
                </Button>
                <Button
                  sx={{ mt: 2, width: "70px" }}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    setParentID({
                      id: undefined,
                      name: undefined,
                    });
                    setOpenShowGroup(false);
                  }}
                >
                  انصراف
                </Button>
              </Box>
            </DialogContent>
          </Dialog>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
